import { create } from 'zustand';

interface ClientRefreshState {
    ClientRefresh: boolean;
    setClientRefresh: (open: boolean) => void;
}

// Create the Zustand store with types
const ClientRefreshStore = create<ClientRefreshState>((set) => ({
    ClientRefresh: false,
    setClientRefresh: (open: boolean) => set({ ClientRefresh: open }),
}));

export default ClientRefreshStore;
